import { CognitoIdentityProviderClient, SignUpCommand, SignUpCommandInput, InitiateAuthCommand, InitiateAuthCommandInput } from "@aws-sdk/client-cognito-identity-provider";
import { CognitoJwtVerifier } from "aws-jwt-verify";

const USER_POOL_ID = import.meta.env.VITE_COGNITO_USER_POOL_ID as string;
const APP_CLIENT_ID = import.meta.env.VITE_COGNITO_APP_CLIENT_ID as string;
const AWS_REGION = import.meta.env.VITE_AWS_REGION as string;

const client = new CognitoIdentityProviderClient({ region: AWS_REGION });

export async function cognitoSignUp(username: string, password: string, firstName: string, lastName: string): Promise<string> {
  console.log(`signing up ${username} - ${USER_POOL_ID} - ${firstName} - ${lastName}`);

  // Prepare the input for the SignUpCommand
  const input: SignUpCommandInput = {
    ClientId: APP_CLIENT_ID,
    Username: username,
    Password: password,
    UserAttributes: [
      { Name: "email", Value: username },
      { Name: "given_name", Value: firstName },
      { Name: "family_name", Value: lastName },
    ]
  };

  try {
    // Send the sign-up request
    const command = new SignUpCommand(input);
    const response = await client.send(command);

    // Check if the registration was successful
    if (response.UserSub) {
      console.log("REGISTER SUCCESS", response.UserSub)
      return response.UserSub; // Return the user's sub (unique identifier)
    } else {
      console.log("REGISTRATION FAIL", response)
      throw new Error("Registration failed: No UserSub received");
    }
  } catch (error) {
    console.error("Error during registration:", error);
    throw error;
  }
}

export async function cognitoLogin(username: string, password: string): Promise<string> {
  const input: InitiateAuthCommandInput = {
    AuthFlow: "USER_PASSWORD_AUTH",
    ClientId: APP_CLIENT_ID,
    AuthParameters: {
      USERNAME: username,
      PASSWORD: password,
    },
  };

  try {
    // Send the authentication request
    const command = new InitiateAuthCommand(input);
    const response = await client.send(command);

    // Check if the authentication was successful
    console.log(response);
    if (response.AuthenticationResult && response.AuthenticationResult.IdToken) {
      localStorage.setItem("idToken", response.AuthenticationResult.IdToken);
      return response.AuthenticationResult.IdToken;
    } else {
      throw new Error("Authentication failed: No ID token received");
    }
  } catch (error) {
    console.error("Error during authentication:", error);
    throw error;
  }
}

export async function checkLoggedIn(): Promise<boolean> {
  const idToken = localStorage.getItem("idToken") as string;
  const verifier = CognitoJwtVerifier.create({
    userPoolId: USER_POOL_ID,
    tokenUse: "id",
    clientId: APP_CLIENT_ID,
  });

  try {
    await verifier.verify(idToken)
  } catch (err: any) {
    console.log(`not logged in - ${err}`);
    // console.log(idToken);
    localStorage.clear();
    return false;
  }
  
  return true;
}
